import { render, staticRenderFns } from "./LearnMore.vue?vue&type=template&id=3580fe54&scoped=true&"
import script from "./LearnMore.vue?vue&type=script&lang=js&"
export * from "./LearnMore.vue?vue&type=script&lang=js&"
import style0 from "./LearnMore.vue?vue&type=style&index=0&id=3580fe54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3580fe54",
  null
  
)

export default component.exports